<template>
  <v-card
      border="0"
      rounded="xl"
      class="overflow-hidden pa-5 card-background d-flex flex-wrap justify-center"
      min-height="200"
      @click="redirect"
  >
    <v-row class="d-flex align-center">
      <v-col cols="12">
        <div class="fs-24 fw-700 text-white">
          {{ title }}
        </div>
        <div class="fs-20 fw-300 text-white">
          {{ subtitle }}
        </div>
      </v-col>
      <v-col cols="12">
        <div class="fs-20 fw-500 text-white">
          {{ action }}
          <v-icon class="fw-bolder" size="18">mdi-chevron-right</v-icon>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>


<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'CardAction',
  props: {
    title: String,
    subtitle: String,
    action: String,
    redirectToRoute: String,
  },
  setup(props) {
    const redirect = () => {
      if (props.redirectToRoute) {
        window.location.href = props.redirectToRoute;
      }
    };

    return {
      redirect
    };
  }
});
</script>

<style scoped>
.fs-25px {
  font-size: 25px;
}

.fw-900 {
  font-weight: 900;
}

.fs-16px {
  font-size: 16px;
}

.fw-300 {
  font-weight: 300;
}

.mt-4 {
  margin-top: 1rem;
}

.fw-bolder {
  font-weight: bolder;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
